import { Spin } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { AddButton, LayoutWithSider } from "src/components/LayoutWithSider";
import { ModalDelete } from "src/components/ModalDelete";
import { VerticalLayout } from "src/components/VerticalLayout";
import { ObjImportModal } from "../../Obj2Tab/ObjImportModal";
import styles from "../../Obj2Tab/Obj2Tab.module.less";
import { ObjectsStore } from "../facade";
import { ResourceView } from "../view/statusView";
import { ObjectsContent } from "./ObjectsContent";
import { ObjectsTree } from "./ObjectsTree";

interface PropsObjectsTab {
  store: ObjectsStore;
}

/**
 * Вкладка объектов и атрибутов.
 *
 * Общее состояние отвечает только за начальную загрузку каталога и
 * справочников. Всё остальное — состояния отдельных объектов, и они
 * показываются на месте, не заслоняя дерево.
 */
export const ObjectsTab: React.FC<PropsObjectsTab> = observer(({ store }) => {
  const [openImport, setOpenImport] = React.useState(false);
  React.useEffect(() => {
    store.init();
  }, []);
  return (
    <ResourceView
      state={store.data}
      onRetry={() => store.init()}
      errorMessage={() => "Не удалось открыть вкладку объектов"}
    >
      {() => (
        <Spin
          spinning={store.refreshing}
          size="large"
          wrapperClassName={styles.refreshSpin}
        >
          <LayoutWithSider
            siderHeader={
              <div className={styles.siderHeader}>
                <AddButton
                  onClick={() => store.safeCreateObject()}
                  id="addObject"
                  text="Добавить объект"
                />
                <AddButton
                  onClick={() => setOpenImport(true)}
                  id="importObject"
                  text="Импорт"
                />
              </div>
            }
            siderContent={<ObjectsTree store={store} />}
          >
            <VerticalLayout>
              <div className={styles.box}>
                <ObjectsContent store={store} />
              </div>
              <ModalDelete
                open={store.isDeleting}
                message={store.messageAboutDelete}
                waiting={store.deletingWait}
                onOk={() => store.doDelete()}
                onCancel={() => store.cancelDelete()}
              />
            </VerticalLayout>
            <ObjImportModal
              open={openImport}
              close={() => setOpenImport(false)}
              store={store.ports}
            />
          </LayoutWithSider>
        </Spin>
      )}
    </ResourceView>
  );
});
